<!-- <div class="loader-wrapper" *ngIf="show$ | async">
    <div class="loader">
        <ng-lottie [options]="lottieOptions" [height]='"150"' [width]='"150"'></ng-lottie>
    </div>
</div>

<div class="loader-wrapper" *ngIf="pagechange$ | async">
    <div class="loader">
        <ng-lottie [options]="lottieOptions" [height]='"150"' [width]='"150"'></ng-lottie>
    </div>
</div>
 -->

<div class="loader-wrapper" *ngIf="show$ | async">
    <div class="loader">
        <img src="assets/images/loader/XE.gif" alt="Hourglass.gif">
    </div>
</div>

<!-- <div class="loader-wrapper" *ngIf="pagechange$ | async">
    <div class="loader">
        <img src="assets/images/loader/XE.gif" alt="Hourglass.gif">
    </div>
</div> -->

    